import Collection from "../collection";

export { hashify, accumulate, flatify, diffuse, eq, eqOrdered, mapEl, keyset, mapObj };





// todo not only { id }, but just id
function normalize(arr) {
    const fn = arr.some( model => model != null && model.hasOwnProperty( 'id' ) )
        ? model => model == null ? String( model ) : +model.id
        : el => el == null ? String( el ) : el;

    return arr.map( fn );
}

function eq(a, b) {
    return normalize( a ).sort().join( ',' ) === normalize( b ).sort().join( ',' );
}

function eqOrdered(a, b) {
    return normalize( a ).join( ',' ) === normalize( b ).join( ',' );
}

function hashify(array = [], fn = (item, hash) => [item, true]) {
    if (array instanceof Collection)
        array = array.toJSON();
        
    return array.reduce( (hash, item) => { 
        const [key, value] = fn( item, hash ); 
        hash[key] = value != undefined ? value : true; 
        return hash; 
    }, {} );
}

function flatify(arrayOfArrays) {
    return arrayOfArrays.reduce( (result, els) => [...result, ...els], [] );
}

function accumulate(keyValues = []) {
    return hashify( keyValues,
        ([key, value], hash) => [
            key, 
            hash[key] ? [...hash[key], value] : [value]
        ] );
}

function keyset(...hashes) {
    const namesList = flatify( hashes.map( hash => Object.keys( hash ) ) );
    return Object.keys( hashify( namesList ) );
}

function diffuse(array, fn) {
    if (!fn)
        return array.slice();

    return array.reduce( (result, item, index) => {
        let pivot; if (index)
            if (pivot = fn( array[index - 1], item ))
                result.push( pivot );

        return result.push( item ), result;
    }, [] );
}

function mapEl(array, findFn, newFn, mapFn) {
    array = [...array || []];

    const index = array.findIndex( findFn );
    const el = mapFn( array[index] || newFn() );

    if (el && index > -1)
        array[index] = el;
    else if (el)
        array.push( el );
    else if (index > -1)
        array.splice( index, 1 );

    return array;
}

function mapObj(obj, fn) {
    return Object.keys( obj ).reduce( 
        (hash, key) => (hash[key] = fn( obj[key] ), hash ), 
        {} );
}




// WEBPACK FOOTER //
// ./src/js/utils/arrays.js